import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

type PatronMessageCardProps = {
  subject: string;
  body: string;
  dualChannel: boolean;
  sending: boolean;
  onSubjectChange: (value: string) => void;
  onBodyChange: (value: string) => void;
  onDualChannelChange: (value: boolean) => void;
  onSend: () => void;
};

export function PatronMessageCard({
  subject,
  body,
  dualChannel,
  sending,
  onSubjectChange,
  onBodyChange,
  onDualChannelChange,
  onSend,
}: PatronMessageCardProps) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Mail className="h-4 w-4" />
          Send message
        </CardTitle>
        <p className="text-sm text-slate-500">
          Delivers an in-app note. Optionally also email the same message.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="patron-msg-subject">Subject</Label>
          <Input
            id="patron-msg-subject"
            value={subject}
            onChange={(e) => onSubjectChange(e.target.value)}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="patron-msg-body">Message</Label>
          <Textarea
            id="patron-msg-body"
            rows={4}
            value={body}
            onChange={(e) => onBodyChange(e.target.value)}
          />
        </div>
        <div className="flex items-center gap-2">
          <Switch
            id="patron-msg-dual"
            checked={dualChannel}
            onCheckedChange={(c) => onDualChannelChange(c === true)}
          />
          <Label htmlFor="patron-msg-dual" className="cursor-pointer text-sm font-normal">
            Also send email
          </Label>
        </div>
        <Button onClick={onSend} disabled={sending}>
          {sending ? <LoadingSpinner size="sm" /> : "Send message"}
        </Button>
      </CardContent>
    </Card>
  );
}
